import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: `Перемещение накладных в контейнер`,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        class: "mt-3",
        value: _ctx.state.containerId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.containerId) = $event)),
        placeholder: "Контейнер",
        "search-without-refresh": "",
        "error-text": "При получении списка контейнеров произошла ошибка",
        label: "title",
        loading: _ctx.data_state.containers.is_loading,
        failed: _ctx.data_state.containers.is_failed,
        options: _ctx.data_state.containers.list,
        disabled: _ctx.loading,
        "is-invalid": _ctx.state_form$.containerId.$error,
        "validation-errors": _ctx.state_form$.containerId.$errors,
        onRefresh: _ctx.loadContainers
      }, null, 8, ["value", "loading", "failed", "options", "disabled", "is-invalid", "validation-errors", "onRefresh"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}